import { catalog, en, type MessageKey } from './messages.js';
import type { LanguageCode } from './types.js';

/**
 * Look up a localized string. Falls back to English per-key when the active
 * language has no translation for it. `en` is always complete (enforced by
 * the `as const` source object and the catalog completeness test).
 */
export function translate(lang: LanguageCode, key: MessageKey): string {
  return catalog[lang]?.[key] ?? en[key];
}

export {
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
  resolveLanguage,
  resolveLanguageWithWarning,
  type LanguageCode,
  type LanguageFallbackReason,
} from './types.js';
export { type MessageKey } from './messages.js';
